import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrl: './terms-conditions.component.scss'
})
export class TermsConditionsComponent {

  termsConditions: SafeHtml;

  constructor(
    private dialogRef: MatDialogRef<TermsConditionsComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const rawHtml: string = data.termsConditions;

    this.termsConditions = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
  }


  close() {
    this.dialogRef.close(true);
  }
}
